<template>
  <print-template :viewFooter="false" :viewHeader="false">
    <svg :id="'PART_ID_' + part.id"></svg>
  </print-template>
</template>
<script>
import PrintTemplate from "@/components/PrintTemplate.vue";
import JsBarcode from "jsbarcode";
import Part from "@/models/Part";
export default {
  name: "PartBarcode",
  components: { PrintTemplate },
  data() {
    return {
      part: new Part()
    };
  },
  updated() {
    JsBarcode(`#PART_ID_${this.part.id}`, `${this.part.part_no}`, {
      format: "CODE39"
    });
  },
  mounted() {
    if (this.$route.params.id) {
      Part.fetch(this.$route.params.id).then(part => {
        this.part = part;
      });
    }
  }
};
</script>
